import type { FC, ReactNode } from 'react'

import { useState } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'

import { cn } from '@/lib/utils'

import { Cart } from '@/components/generals/cart'

const navLinks = [
    { label: 'Features', href: '/features' },
    { label: 'About', href: '/about' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Blog', href: '/blog' }
]

export const Navbar: FC = (): ReactNode => {
    const router = useRouter()
    const [menuOpen, setMenuOpen] = useState(false)

    const isHome = router.pathname === '/'
    const isActive = (href: string): boolean =>
        href === '/blog' ? router.pathname.startsWith('/blog') : router.pathname === href

    return (
        <div
            role='banner'
            data-collapse='medium'
            data-animation='default'
            data-duration='500'
            className='navbar w-nav'
        >
            <div className='container nav-container'>
                <div className='nav-menu-container'>
                    <Link
                        href='/'
                        aria-current={isHome ? 'page' : undefined}
                        className={cn('brand w-nav-brand', isHome && 'w--current')}
                    >
                        <img src='/images/Logo-white.svg' loading='lazy' alt='Black Plus' className='brand-image' />
                    </Link>

                    <nav
                        role='navigation'
                        className='nav-menu w-nav-menu'
                        {...(menuOpen ? { 'data-nav-menu-open': '' } : {})}
                    >
                        <div className='nav-link'>
                            {navLinks.map(({ label, href }) => (
                                <div key={href} className='nav-link-active-holder'>
                                    <Link
                                        href={href}
                                        onClick={() => setMenuOpen(false)}
                                        aria-current={isActive(href) ? 'page' : undefined}
                                        className={cn('nav-link-holder w-inline-block', isActive(href) && 'w--current')}
                                    >
                                        <div className='nav-link-text-holder'>
                                            <div className='nav-link-text'>{label}</div>
                                        </div>
                                    </Link>
                                    <Link
                                        href={href}
                                        tabIndex={-1}
                                        aria-hidden='true'
                                        onClick={() => setMenuOpen(false)}
                                        className={cn('cricle-active-holder w-inline-block', isActive(href) && 'w--current')}
                                    />
                                </div>
                            ))}

                            <div className='nav-button-holder nav-button-on-mobile'>
                                <Link
                                    href='/#sign-up'
                                    onClick={() => setMenuOpen(false)}
                                    className='button navbar-button w-button'
                                >
                                    Sign up
                                </Link>
                            </div>
                        </div>
                    </nav>

                    <Cart />

                    <div className='nav-button-holder'>
                        <Link href='/#sign-up' className='button navbar-button w-button'>Sign up</Link>
                    </div>

                    <div
                        role='button'
                        tabIndex={0}
                        aria-label='Menu'
                        aria-expanded={menuOpen}
                        onClick={() => setMenuOpen((value) => !value)}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault()
                                setMenuOpen((value) => !value)
                            }
                        }}
                        className={cn('menu-button w-nav-button', menuOpen && 'w--open')}
                    >
                        <div className='center-box'>
                            <img src='/images/menu.svg' loading='lazy' alt='' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
